import Service, { inject as service } from '@ember/service';
import FeaturesService from 'ember-feature-flags/services/features';
import DS from 'ember-data';
import AuthService from 'cio/services/auth';
import { UserFlags } from 'cio/models/user';

export default class AIService extends Service {
  @service features!: FeaturesService;
  @service store!: DS.Store;
  @service auth!: AuthService;

  // Account level AI feature flag to enable/disable all AI features
  readonly #isAIEnabled = this.features.isEnabled('ai_enabled');

  // Used for checking if a specific AI feature is enabled for a specific user
  isAiFeatureEnabledForUser(feature: keyof UserFlags) {
    return this.#isAIEnabled && this.auth.user?.userFlags[feature] === true;
  }
}
